import { render, staticRenderFns } from "./MarksDialog.vue?vue&type=template&id=6ce82d1a"
import script from "./MarksDialog.vue?vue&type=script&lang=js"
export * from "./MarksDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports